module.exports = __webpack_public_path__ + "static/media/redbubble-logo.0d4ffac1.png";